import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LoadingSpinner } from "./ui/loading-spinner";

interface CreatorRouteProps {
  children: React.ReactNode;
}

export const CreatorRoute = ({ children }: CreatorRouteProps) => {
  const {
    user,
    loading,
    hasRole,
    isAdminOrStaff,
    needsPasswordChange,
    needsTermsAcceptance,
    isOAuthUser,
  } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/auth?redirect=/creators/dashboard", { replace: true });
      return;
    }
    // Same gating as ProtectedRoute: email/password creators with a pending
    // password change or terms acceptance are sent to the shared /setup-password page.
    if (!isOAuthUser && (needsPasswordChange || needsTermsAcceptance)) {
      navigate("/setup-password", { replace: true });
      return;
    }
    // Allow creators OR admin/staff (for support/QA)
    if (!hasRole("creator") && !isAdminOrStaff()) {
      navigate("/", { replace: true });
    }
  }, [user, loading, hasRole, isAdminOrStaff, needsPasswordChange, needsTermsAcceptance, isOAuthUser, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user || (!hasRole("creator") && !isAdminOrStaff())) return null;
  if (!isOAuthUser && (needsPasswordChange || needsTermsAcceptance)) return null;
  return <>{children}</>;
};
